module.exports = __webpack_public_path__ + "static/about_agencyvista5-f75cbb99c6d55757464d902f642db56f.jpg";